import { createApp } from 'vue'
import Sandbox from '../views/sandbox/Sandbox.vue'
import { PublishPaymentMethodItem } from '../apis/types/payment'
import { createPaymentDropinOrder } from '../apis/payment'
import { PAYMENT_APP_VERSION } from '../const'

export const createSandboxDropIn = (config: {
  clientId: string
  sdkVersion?: string
  orderInfo: any
  onSubmit?: () => void
  onError?: (error: any) => void
  onCreateOrder?: (result: any) => void
  onCompleted?: () => void
  onFailed?: (result: any) => void
}) => {
  const { orderInfo, onSubmit, onError, onCreateOrder, onCompleted, onFailed } = config

  const createOrder = async (payment_method_id: string, isSuccess: boolean) => {
    const result = await createPaymentDropinOrder({
      dropin_channel_data: JSON.stringify({
        is_successful: isSuccess,
      }),
      payment_channel_type: 11,
      payment_method_id,
      sys_order_id: orderInfo?.sys_order_id,
      sdk_version: config.sdkVersion || PAYMENT_APP_VERSION,
    })

    onCreateOrder?.(result)

    return result
  }

  const setup = async (containerId: string, paymentMethod: PublishPaymentMethodItem) => {
    const app = createApp(Sandbox, {
      createOrder: (isSuccess: boolean) => createOrder(paymentMethod.payment_method_id, isSuccess),
      onSubmit,
      onError,
      onCompleted,
      onFailed,
    })

    app.mount(containerId)
  }

  return {
    setup,
  }
}
